import { ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { Field } from "react-final-form";
import ButtonContainer from "@components/ButtonContainer";
import FormTextField from "@components/Shared/FormTextField";
import renderSelectField from "@easydev/form/Select";
import useStates from "@mappers/Shared/getState.mapper";
import OrderNumericAscendingIcon from "mdi-react/OrderNumericAscendingIcon";
import FormatTitleIcon from "mdi-react/FormatTitleIcon";
import TextLongIcon from "mdi-react/TextLongIcon";
import IFormProps from "@interfaces/Shared/formProps";
import IBenefit from "@interfaces/Clients/WhaleShark/benefits/benefit";

interface IModifyForm extends IFormProps {
  data: IBenefit;
}

const ModifyForm = ({ handleSubmit, data }: IModifyForm): ReactElement => {
  const { t } = useTranslation(["core", "whaleshark"]);
  const { GetState, GetStates } = useStates();
  const [status] = useState(GetState(data?.state));

  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.title")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <FormatTitleIcon />
          </div>
          <Field
            name="title"
            component={FormTextField}
            type="text"
            placeholder={t("core:common.title")}
            isAboveError
            initialValue={data?.title}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">
          {t("core:common.description")}
        </span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <TextLongIcon />
          </div>
          <Field
            name="description"
            component={FormTextField}
            type="text"
            placeholder={
              "Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit optio ipsam quas maxime deleniti officiis molestias eaque a? Ea ipsum expedita exercitationem saepe sapiente accusamus aliquid architecto rem deleniti ad!"
            }
            isAboveError
            initialValue={data?.description}
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.order")}</span>
        <div className="form__form-group-field">
          <div className="form__form-group-icon">
            <OrderNumericAscendingIcon />
          </div>
          <Field
            name="order"
            component={FormTextField}
            type="number"
            initialValue={data?.order}
            min={0}
            isAboveError
          />
        </div>
      </div>

      <div className="form__form-group">
        <span className="form__form-group-label">{t("core:common.state")}</span>
        <div className="form__form-group-field">
          <Field
            name="state"
            component={renderSelectField}
            type="text"
            placeholder={`${t("core:common.select_placeholder")} ${t(
              "core:common.state"
            )}`}
            options={GetStates()}
            initialValue={status}
          />
        </div>
      </div>

      <ButtonContainer />
    </form>
  );
};

export default ModifyForm;
